export enum TPortalType {
  Retailer = 'Retailer',
  MJC = 'MJC',
  Consumer = 'Consumer',
  ConsumerMobile = 'ConsumerMobile',
  System = 'System',
  TechPortal = 'TechPortal',
}
